import React from 'react';
import PropTypes from 'prop-types';

import './Dropdown.sass';

import cx from 'classnames';

function DropdownItem({active, children, component: Component = 'div', className, ...rest}) {
  return (
    <Component {...rest} className={cx('dropdown__item', className)}>
      {children}
    </Component>
  );
}

DropdownItem.propTypes = {active: PropTypes.bool};

export default class Dropdown extends React.PureComponent {
  static Item = DropdownItem;

  constructor(props) {
    super(props);
    this.state = {isOpen: false};
  }

  _hide = () => this.setState({isOpen: false});

  componentDidUpdate() {
    if (this.state.isOpen) {
      setTimeout(() => {
        window.addEventListener('click', this._hide);
      }, 1);
    } else {
      window.removeEventListener('click', this._hide);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this._hide);
  }

  render() {
    const {wide, children} = this.props;
    const {isOpen} = this.state;

    const childrenArray = React.Children.toArray(children);

    const activeChild = childrenArray.find(it => !!it.props.active) || childrenArray[0];
    const dropdownList = childrenArray.filter(it => it !== activeChild);

    return (
      <div
        className={cx(
          'dropdown',
          isOpen && 'dropdown--active',
          wide && 'dropdown--wide'
        )}
        onClick={() => this.setState({isOpen: !isOpen})}
      >
        <button className="dropdown__trigger">{activeChild.props.children}</button>
        <div className="dropdown__content">{dropdownList}</div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./components/dropdown/Dropdown.js